// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import UserRolesEditScreen from "../../../src/screens/user-roles/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} UserRoleEditRouteProps */

/** @typedef {Record<string, never>} UserRoleEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<UserRoleEditRouteProps, UserRoleEditRouteState>}
 */
class UserRoleEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit user role")}</ScreenTitle>
        <UserRolesEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<UserRoleEditRouteProps>} */
const UserRoleEditRouteComponent = memo(shapeComponent(UserRoleEditRoute))

export default UserRoleEditRouteComponent
